import React, { useEffect, useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { uploadPageURL, newUploadToken } from "./api";

// UploadQR is the QR code a GM scans to add photos to a fault report, with its countdown and a
// renew button once it has expired. Used right after creation and from the detail panel
// ("Tilføj billeder"). The token is scoped to this one issue and lives 30 minutes.
export default function UploadQR({ issueKey, title, initialToken, initialExpiresAt }) {
    const [token, setToken] = useState(initialToken || "");
    const [expiresAt, setExpiresAt] = useState(initialExpiresAt || 0);
    const [now, setNow] = useState(Date.now() / 1000);
    const [error, setError] = useState("");

    async function renew() {
        setError("");
        try {
            const t = await newUploadToken(issueKey);
            setToken(t.upload_token);
            setExpiresAt(t.expires_at);
        } catch {
            setError("Kunne ikke lave en ny kode. Prøv igen.");
        }
    }

    // No token handed in (opened from the detail panel) → fetch one straight away.
    useEffect(() => {
        if (!initialToken) renew();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [issueKey]);

    useEffect(() => {
        const clock = setInterval(() => setNow(Date.now() / 1000), 1000);
        return () => clearInterval(clock);
    }, []);

    const secondsLeft = Math.max(0, Math.floor(expiresAt - now));
    const expired = !token || secondsLeft === 0;
    const link = token ? uploadPageURL(issueKey, token, title) : "";

    return (
        <div className="fr-qr-layout">
            <div className={`fr-qr ${expired ? "expired" : ""}`}>
                <QRCodeSVG
                    value={link || "https://riddlehouse.dk"}
                    size={232}
                    level="H" // highest error correction, so the logo in the middle costs nothing in scannability
                    bgColor="#ffffff"
                    fgColor="#0d0f14"
                    marginSize={2}
                    imageSettings={{ src: "/riddlehouse-logo.svg", height: 48, width: 48, excavate: true }}
                />
                {expired && <button className="fr-primary fr-qr-renew" onClick={renew}>{token ? "Lav ny QR-kode" : "Henter…"}</button>}
            </div>
            <div className="fr-qr-text">
                <h2>Tag billeder med telefonen</h2>
                <ol>
                    <li>Scan QR-koden med kameraet på din telefon.</li>
                    <li>Tryk <b>Tag billede</b> på siden der åbner, eller vælg fra kamerarullen.</li>
                    <li>Billederne dukker op her på siden, når de er sendt.</li>
                </ol>
                <p className="fr-hint">
                    {expired ? "QR-koden er udløbet." : `Koden virker i ${Math.floor(secondsLeft / 60)}:${String(secondsLeft % 60).padStart(2, "0")} endnu.`}
                    {" "}Den kan kun lægge billeder på denne fejlmelding.
                </p>
                {error && <div className="fr-error">{error}</div>}
            </div>
        </div>
    );
}
